import {
    Box,
    Chip,
    Divider,
    Grid,
    Stack,
    Typography,
} from '@mui/material';

import { Cashiers } from './Cashiers';

export const Categories = ({ useFetchInit, dataAssignments }) => {

    return (
        <>
            {dataAssignments.map((category) => {
                const dataCashiers = category.cajas ?? [];

                return (
                    <Box key={category.idcategoria}>
                        <Stack
                            direction="row"
                            alignItems="center"
                            spacing={1.5}
                            sx={{ mb: 1.5 }}
                        >
                            <Typography variant="h6" fontWeight={700}>
                                {category.nombre}
                            </Typography>

                            <Chip
                                size="small"
                                label={`${dataCashiers.length} ${
                                    dataCashiers.length === 1 ? 'caja' : 'cajas'
                                }`}
                            />
                        </Stack>

                        <Divider sx={{ mb: 2 }} />

                        {dataCashiers.length === 0 ? (
                            <Typography variant="body2" color="text.secondary">
                                No hay cajas registradas en esta categoría.
                            </Typography>
                        ) : (
                            <Grid container spacing={2}>
                                <Cashiers
                                    useFetchInit={useFetchInit}
                                    dataCashiers={dataCashiers}
                                    category={category.nombre}
                                />
                            </Grid>
                        )}
                    </Box>
                );
            })}
        </>
    )
}
